import { render, staticRenderFns } from "./VariationsLists.vue?vue&type=template&id=af0487ca&"
import script from "./VariationsLists.vue?vue&type=script&lang=js&"
export * from "./VariationsLists.vue?vue&type=script&lang=js&"
import style0 from "./VariationsLists.vue?vue&type=style&index=0&id=af0487ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports